import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import analytics from "@/lib/analytics";

/**
 * Mount-once tracker that lives inside <BrowserRouter>. It wires the global
 * analytics listeners and drives pageview boundaries off the router location.
 *
 * Tracking is a no-op when disabled (inside an iframe or on /admin paths) —
 * the analytics module guards every entry point, so this component stays inert
 * in those contexts. Renders nothing.
 */
const AnalyticsTracker = () => {
  const { pathname } = useLocation();

  // Attach global listeners + timers once for the app's lifetime.
  useEffect(() => {
    analytics.init();
  }, []);

  // On every route change: close out the previous pageview, open the new one.
  useEffect(() => {
    if (!analytics.isEnabled()) return;
    analytics.startPageview(pathname);
    return () => {
      analytics.endPageview();
    };
  }, [pathname]);

  return null;
};

export default AnalyticsTracker;
